/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// import MakeDonationWidget from "./components/make-donation/MakeDonationWidget";



require('./bootstrap');
import { createApp } from 'vue'
import { store } from './store'

import Notifications from '@kyvg/vue3-notification'
import WidgetNotifications from './components/make-donation/WidgetNotifications.vue'

import mitt from 'mitt'
const emitter = mitt();

import vClickOutside from "click-outside-vue3"
import SocialSharing from 'vue-social-sharing'

import FloatingVue from 'floating-vue'



// import VueObserveVisibility from 'vue-observe-visibility'
// Vue.use(VueObserveVisibility)
//

//
// var VueScrollTo = require('vue-scrollto')
// Vue.use(VueScrollTo, {
//   duration: 1500,
// })
//
// // import { Datetime } from 'vue-datetime'
// import 'vue-datetime/dist/vue-datetime.css'
// // Vue.use(Datetime)
//
//
// Vue.component('Multiselect', require('vue-multiselect').default)
// import 'vue-multiselect/dist/vue-multiselect.min.css'
//
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// // Install BootstrapVue
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)
//
// // import CKEditor from '@ckeditor/ckeditor5-vue2';
// // Vue.use( CKEditor );
//
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
// Vue.use(VueQuillEditor, /* { default global options } */)
//
// import vClickOutside from 'v-click-outside'
// Vue.use(vClickOutside)
//

//
// import VueSimpleAlert from "vue-simple-alert";
// Vue.use(VueSimpleAlert);

// Vue.component('campaign-page', require('./components/campaigns/campaign-page/CampaignPage.vue').default);
// Vue.component('my-donate-button', require('./components/donate-button/MyDonateButton.vue').default);
// Vue.component('my-sticky-donate-button', require('./components/donate-button/MyStickyDonateButton.vue').default);
//
// // Vue.component('campaign-event', require('./components/campaigns/campaign-event/CampaignEvent.vue').default); not used anymore 5/13/21
// Vue.component('add-campaign-event-button', require('./components/campaigns/campaign-event/AddCampaignEventButton.vue').default);
// Vue.component('edit-campaign-event-link', require('./components/campaigns/campaign-event/EditCampaignEventLink.vue').default);
//
// Vue.component('profile-form', require('./components/settings/ProfileForm.vue').default);
// Vue.component('donation-widget', require('./components/make-donation/MakeDonationWidget.vue').default);
// Vue.component('donation-widget-no-modal', require('./components/make-donation/MakeDonationWidgetNonModal.vue').default);

//
// Vue.component('date-time-picker', require('./components/utilities/DateTimePicker.vue').default);
// Vue.component('mobile-top-navigation', require('./components/layout/MobileTopNavigation.vue').default);
// Vue.component('crud-button', require('./components/general/CrudButton.vue').default);


// // Vue.component('pledge-drive-campaign-goal', require('./components/campaigns/campaign-page/campaign-goal/PledgeDriveCampaignGoal.vue').default);

import Dashboard from './components/dashboard/Dashboard.vue'
import FoundationTemplateContentEditor from './components/admin/FoundationTemplateContentEditor.vue'
import FoundationTemplatePreview from './components/admin/template-editor/FoundationTemplatePreview.vue'
import DigPinkCampaignPageV2 from './components/campaigns/templates/DigPinkCampaignPageV2.vue'
import V2CampaignActivities from './components/campaigns/campaign-page/v2/V2CampaignActivities.vue'
import ImpactSlider from './components/impact-slider/ImpactSlider.vue'

import CampaignEvent from './components/campaigns/campaign-event/CampaignEvent.vue'
import AddCampaignEventButton from './components/campaigns/campaign-event/AddCampaignEventButton.vue'
import EditCampaignEventLink from './components/campaigns/campaign-event/EditCampaignEventLink.vue'

import ProfileForm from './components/settings/ProfileForm.vue'

import CheckDeposit from './components/deposits/CheckDeposit.vue'
import CreateDepositButton from './components/deposits/CreateDepositButton.vue'
import CloseDepositButton from './components/deposits/CloseDepositButton.vue'
import DepositNameLink from './components/deposits/DepositNameLink.vue'
import DepositIdLink from './components/deposits/DepositIdLink.vue'
import AddFileToDepositButton from './components/deposits/AddFileToDepositButton.vue'
import OpenDepositCrudButton from './components/deposits/OpenDepositCrudButton.vue'
import CompletedDepositCrudButton from './components/deposits/CompletedDepositCrudButton.vue'
import DepositSearch from './components/deposits/DepositSearch.vue'
import RemoveDepositFileCrudButton from './components/deposits/RemoveDepositFileCrudButton.vue'
import DepositViewPageCrudButton from './components/deposits/DepositViewPageCrudButton.vue'

import CampaignSignUpThankYou from './components/campaigns/CampaignSignUpThankYou.vue'
import QuickAddChild from './components/campaigns/QuickAddChild.vue'
import BatchImportModal from './components/campaigns/BatchImportModal.vue'
import MakePledgeWidget from './components/campaigns/campaign-page/pledge-drives/MakePledgeWidget.vue'
import MakePledgeWidgetNonModal from './components/campaigns/campaign-page/pledge-drives/MakePledgeWidgetNonModal.vue'
import AddPledgeActivityButton from './components/campaigns/campaign-page/pledge-drives/AddPledgeActivityButton.vue'
import AddPledgeButton from './components/campaigns/campaign-page/pledge-drives/AddPledgeButton.vue'
import ImportPledgeButton from './components/campaigns/campaign-page/pledge-drives/ImportPledgeButton.vue'


import CampaignStats from './components/admin/reports/CampaignStats.vue'
import CampaignStatListResult from './components/admin/reports/CampaignStatListResult.vue'
import ImpactLeaderboard from './components/admin/reports/ImpactLeaderboard.vue'
import CampaignLeaderboard from './components/admin/reports/CampaignLeaderboard.vue'

// User-facing Campaign Impact Components
import CampaignImpactDashboard from './components/campaigns/campaign-impact/CampaignImpactDashboard.vue'
import YourCampaignTab from './components/campaigns/campaign-impact/YourCampaignTab.vue'
import LeaderboardTab from './components/campaigns/campaign-impact/LeaderboardTab.vue'

import RepresentativePage from './components/admin/representatives/RepresentativePage.vue'
import RepresentativeList from './components/admin/representatives/RepresentativeList.vue'
import RepresentativeCrudButton from './components/admin/representatives/RepresentativeCrudButton.vue'
import RepresentativeForm from './components/admin/representatives/RepresentativeForm.vue'
import RepresentativeModal from './components/admin/representatives/RepresentativeModal.vue'

// Salesforce Integration Components
import SalesforceMonitoringDashboard from './components/Salesforce/SalesforceMonitoringDashboard.vue'
import SalesforceEmailReport from './components/Salesforce/SalesforceEmailReport.vue'
import SalesforceCampaignHealth from './components/Salesforce/SalesforceCampaignHealth.vue'
import SalesforceCampaignHealthPaginated from './components/Salesforce/SalesforceCampaignHealthPaginated.vue'
import BulkSyncProgressBanner from './components/Salesforce/BulkSyncProgressBanner.vue'

import TopHeader from './components/layout/TopHeader.vue'
import TopHeaderV2 from './components/layout/TopHeaderV2.vue'
import DesktopSidebar from './components/layout/DesktopSidebar.vue'
import MobileLeftNavigation from './components/layout/MobileLeftNavigation.vue'
import DigPinkFooter from './components/layout/DigPinkFooter.vue'
import LoginModal from './components/auth/LoginModal.vue'
import AuthModal from './components/auth/AuthModal.vue'
import LoginModalWrapper from './components/auth/LoginModalWrapper.vue'
import InlineAuth from './components/auth/InlineAuth.vue'

import EditCampaign from './components/campaigns/EditCampaign.vue'
import AdminCampaignTypeSelector from './components/admin/AdminCampaignTypeSelector.vue'
import DigPinkCampaignPage from './components/campaigns/templates/DigPinkCampaignPage.vue'
import PerfectPassCampaignPage from './components/campaigns/templates/PerfectPassCampaignPage.vue'
import DiyCampaignPage from './components/campaigns/templates/DiyCampaignPage.vue'
import PledgeDriveCampaignPage from './components/campaigns/templates/PledgeDriveCampaignPage.vue'
import MyStickyDonateButton from './components/donate-button/MyStickyDonateButton.vue'
import MyDonateButton from './components/donate-button/MyDonateButton.vue'
import MyDonateButtonHeader from './components/donate-button/MyDonateButtonHeader.vue'
import MakeDonationWidget from './components/make-donation/MakeDonationWidget.vue'
import EmployerMatchForm from './components/make-donation/EmployerMatchForm.vue'
import ShareLink from './components/share-link/ShareLink.vue'

import DonationSearchCrudButton from './components/donation-search/DonationSearchCrudButton.vue'
import DonationSearch from './components/donation-search/DonationSearch.vue'
import MoveDonation from './components/donation-search/MoveDonation.vue'

import UserSearchCrudButton from './components/user-search/UserSearchCrudButton.vue'
import UserSearch from './components/user-search/UserSearch.vue'
import EditAUser from './components/user-search/EditAUser.vue'
import AllowAnotherCampaign from './components/user-search/AllowAnotherCampaign.vue'

import CampaignSearchInput from './components/campaigns/CampaignSearchInput.vue'
import CampaignForm from './components/campaigns/CampaignForm.vue'

import CampaignSearchCrudButton from './components/campaign-search/CampaignSearchCrudButton.vue'
import CampaignSearch from './components/campaign-search/CampaignSearch.vue'
import MoveCampaign from './components/campaign-search/MoveCampaign.vue'

import SupportACampaign from './components/campaigns/SupportACampaign.vue'

import CampaignCard from './components/campaign-card/CampaignCard.vue'
import CampaignCardList from './components/campaign-card/CampaignCardList.vue'
import CampaignCardCrudButton from './components/campaign-card/CampaignCardCrudButton.vue'
import UpdateCampaignCardModal from './components/campaign-card/UpdateCampaignCardModal.vue'

// Email Composer
import EmailComposer from './components/admin/email-composer/EmailComposer.vue'

// Salesforce Integration Components
import SalesforceSettings from './components/admin/salesforce/SalesforceSettings.vue'
import ConfigurationForm from './components/admin/salesforce/ConfigurationForm.vue'
import FieldMappingEditor from './components/admin/salesforce/FieldMappingEditor.vue'
import SyncHistory from './components/admin/salesforce/SyncHistory.vue'
import SalesforceLogsPage from './components/admin/salesforce/SalesforceLogsPage.vue'
import TabbedConfiguration from './components/admin/salesforce/TabbedConfiguration.vue'
import BasicSetupTab from './components/admin/salesforce/tabs/BasicSetupTab.vue'
import ConnectionSettingsTab from './components/admin/salesforce/tabs/ConnectionSettingsTab.vue'
import SyncSettingsTab from './components/admin/salesforce/tabs/SyncSettingsTab.vue'
import FieldMappingsTab from './components/admin/salesforce/tabs/FieldMappingsTab.vue'
import TestReviewTab from './components/admin/salesforce/tabs/TestReviewTab.vue'

import VueGoogleMaps from '@fawmi/vue-google-maps'
import VueScrollTo from 'vue-scrollto'
import VueSmoothScroll from 'vue3-smooth-scroll'


const app = createApp({
    data() {
        return {
            // Inline auth data for campaign forms
            showInlineAuth: false,
            userEmailExists: null,
            userEmail: '',
            // Campaign ID for the donation widget
            newCampaignId: '',
            campaignIdForDonation: null
        };
    },
    methods: {
        handleAuthSuccess(user) {
            console.log('Auth success:', user);
            // Handle successful authentication
            if (user) {
                this.userEmail = user.email;
                this.showInlineAuth = false;
            }
        },
        handleForgotPassword() {
            console.log('Forgot password clicked');
            // Handle forgot password action
            // Could emit event or show modal
            this.$emit('show-forgot-password');
        }
    }
});

app.use(Notifications)
app.use(vClickOutside)
app.use(SocialSharing)
app.use(FloatingVue)

app.use(store)

app.use(VueScrollTo, {
    duration: 1500,
    offset: -100
})

app.use(VueSmoothScroll, {
    duration: 400,
})

app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBxD0ASpTA8JUwY1EY0uPWDoMTqn3ONYuw',
        libraries: "places"
    },
    loadingStrategy: 'async'
})

app.component('widget-notifications', WidgetNotifications)
app.component('dashboard',  Dashboard)
app.component('foundation-template-content-editor', FoundationTemplateContentEditor)
app.component('foundation-template-preview', FoundationTemplatePreview)
app.component('dig-pink-campaign-page-v2', DigPinkCampaignPageV2)
app.component('v2-campaign-activities', V2CampaignActivities)

app.component('impact-slider', ImpactSlider)
app.component('add-campaign-event-button',  AddCampaignEventButton)
app.component('campaign-event',  CampaignEvent)
app.component('edit-campaign-event-link',  EditCampaignEventLink)

app.component('profile-form',  ProfileForm)
app.component('user-search',  UserSearch)
app.component('user-search-crud-button',  UserSearchCrudButton)
app.component('edit-a-user',  EditAUser)
app.component('allow-another-campaign',  AllowAnotherCampaign)

app.component('check-deposit',  CheckDeposit)
app.component('create-deposit-button',  CreateDepositButton)
app.component('close-deposit-button',  CloseDepositButton)
app.component('deposit-name-link',  DepositNameLink)
app.component('deposit-id-link',  DepositIdLink)
app.component('add-file-to-deposit-button',  AddFileToDepositButton)
app.component('open-deposit-crud-button',  OpenDepositCrudButton)
app.component('completed-deposit-crud-button',  CompletedDepositCrudButton)
app.component('deposit-search',  DepositSearch)
app.component('remove-deposit-file-crud-button',  RemoveDepositFileCrudButton)
app.component('deposit-view-page-crud-button',  DepositViewPageCrudButton)


app.component('campaign-sign-up-thank-you',  CampaignSignUpThankYou)

app.component('make-pledge-widget',  MakePledgeWidget)
app.component('make-pledge-widget-non-modal',  MakePledgeWidgetNonModal)
app.component('add-pledge-activity-button',  AddPledgeActivityButton)
app.component('add-pledge-button',  AddPledgeButton)
app.component('import-pledge-button',  ImportPledgeButton)

app.component('campaign-card',  CampaignCard)
app.component('campaign-card-list',  CampaignCardList)
app.component('campaign-card-crud-button',  CampaignCardCrudButton)
app.component('update-campaign-card-modal',  UpdateCampaignCardModal)

// Salesforce Integration Components
app.component('salesforce-settings', SalesforceSettings)
app.component('configuration-form', ConfigurationForm)
app.component('field-mapping-editor', FieldMappingEditor)
app.component('sync-history', SyncHistory)
app.component('salesforce-logs-page', SalesforceLogsPage)
app.component('tabbed-configuration', TabbedConfiguration)
app.component('basic-setup-tab', BasicSetupTab)
app.component('connection-settings-tab', ConnectionSettingsTab)
app.component('sync-settings-tab', SyncSettingsTab)
app.component('field-mappings-tab', FieldMappingsTab)
app.component('test-review-tab', TestReviewTab)

app.component('support-a-campaign',  SupportACampaign)
app.component('campaign-search',  CampaignSearch)
app.component('campaign-search-crud-button',  CampaignSearchCrudButton)
app.component('move-campaign',  MoveCampaign)

app.component('campaign-search-input',  CampaignSearchInput)
app.component('campaign-form',  CampaignForm)

app.component('donation-search',  DonationSearch)
app.component('donation-search-crud-button',  DonationSearchCrudButton)
app.component('move-donation',  MoveDonation)

app.component('edit-campaign',  EditCampaign)
app.component('admin-campaign-type-selector', AdminCampaignTypeSelector)
app.component('dig-pink-campaign-page', DigPinkCampaignPage)
app.component('perfect-pass-campaign-page', PerfectPassCampaignPage)
app.component('diy-campaign-page', DiyCampaignPage)
app.component('pledge-drive-campaign-page', PledgeDriveCampaignPage)
app.component('my-sticky-donate-button',  MyStickyDonateButton)
app.component('my-donate-button',  MyDonateButton)
app.component('my-donate-button-header',  MyDonateButtonHeader)
app.component('make-donation-widget',  MakeDonationWidget)
app.component('employer-match-form',  EmployerMatchForm)
app.component('share-link',  ShareLink)

app.component('campaign-stats',  CampaignStats)
app.component('campaign-stat-list-result',  CampaignStatListResult)
app.component('impact-leaderboard', ImpactLeaderboard)
app.component('campaign-leaderboard', CampaignLeaderboard)

// User-facing Campaign Impact Components
app.component('campaign-impact-dashboard', CampaignImpactDashboard)
app.component('your-campaign-tab', YourCampaignTab)
app.component('leaderboard-tab', LeaderboardTab)

// Salesforce Integration Components
app.component('salesforce-monitoring-dashboard', SalesforceMonitoringDashboard)
app.component('salesforce-email-report', SalesforceEmailReport)
app.component('salesforce-campaign-health', SalesforceCampaignHealth)
app.component('salesforce-campaign-health-paginated', SalesforceCampaignHealthPaginated)
app.component('bulk-sync-progress-banner', BulkSyncProgressBanner)

app.component('representative-page',  RepresentativePage)
app.component('representative-list',  RepresentativeList)
app.component('representative-crud-button',  RepresentativeCrudButton)
app.component('representative-form',  RepresentativeForm)
app.component('representative-modal',  RepresentativeModal)

app.component('top-header',  TopHeader)
app.component('top-header-v2', TopHeaderV2)
app.component('desktop-sidebar',  DesktopSidebar)
app.component('mobile-left-navigation',  MobileLeftNavigation)
app.component('dig-pink-footer',  DigPinkFooter)
app.component('login-modal',  LoginModal)
app.component('auth-modal',  AuthModal)
app.component('login-modal-wrapper',  LoginModalWrapper)
app.component('inline-auth',  InlineAuth)

app.component('donation-widget-iframe', require('./components/make-donation/DonationWidgetIframe.vue').default);

app.component('quick-add-child', QuickAddChild);
app.component('batch-import-modal', BatchImportModal);

app.component('email-composer', EmailComposer);

app.config.globalProperties.emitter = emitter;
window.emitter = emitter; // Expose emitter globally for donation modal

/* v-reveal: scroll-triggered fade+rise for v2 section entry animations.
   Initial state (opacity 0, translateY 20px) is set in mounted() — no
   FOUC, no CSS dependency. IntersectionObserver toggles to visible
   when the element crosses 15% of the viewport. One-shot — unobserves
   once revealed. Respects prefers-reduced-motion. Matches the pattern
   Lovable uses on its campaign landing page. */
app.directive('reveal', {
  mounted(el) {
    if (typeof IntersectionObserver === 'undefined') return
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduced) return

    el.style.opacity = '0'
    el.style.transform = 'translateY(20px)'
    el.style.transition = 'opacity 600ms cubic-bezier(0.16, 1, 0.3, 1), transform 600ms cubic-bezier(0.16, 1, 0.3, 1)'
    el.style.willChange = 'opacity, transform'

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        entry.target.style.opacity = '1'
        entry.target.style.transform = 'none'
        // Drop willChange after the transition settles — keeps GPU
        // memory free once the element is static.
        setTimeout(() => { entry.target.style.willChange = 'auto' }, 700)
        obs.unobserve(entry.target)
      })
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' })

    observer.observe(el)
    el._revealObserver = observer
  },
  unmounted(el) {
    if (el._revealObserver) el._revealObserver.disconnect()
  },
})

// Add error handling for Vue mount
app.config.errorHandler = (err, instance, info) => {
    console.error('Vue Error:', err);
    console.error('Error Info:', info);
    if (instance) {
        console.error('Component:', instance.$options.name || 'Unknown');
    }
};

try {
    window.app = app.mount('#app');
} catch (error) {
    console.error('Failed to mount Vue app:', error);
    // Try to provide a fallback or graceful degradation
    if (error.message && error.message.includes('Cannot read properties of null')) {
        console.error('The #app element was not found. Make sure the page has a div with id="app"');
    }
}

// const app = new Vue({
//   el: '#app',
//   store
// });
